import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

const PageHeader = ({ eyebrow, title, subtitle, breadcrumb }) => {
  return (
    <section className="bg-neutral-50 border-b border-neutral-200">
      <div className="max-w-[1280px] mx-auto px-5 md:px-10 py-16 md:py-24">
        <nav className="flex items-center gap-1 text-sm text-neutral-500 mb-6">
          <Link to="/" className="hover:text-neutral-900 transition-colors">Home</Link>
          <ChevronRight size={14} />
          <span className="text-neutral-900">{breadcrumb || title}</span>
        </nav>
        {eyebrow && (
          <p className="text-sm tracking-[0.3em] uppercase text-neutral-500 mb-3">{eyebrow}</p>
        )}
        <h1 className="text-4xl md:text-6xl font-bold text-neutral-900 leading-tight mb-5">
          {title}
        </h1>
        {subtitle && (
          <p className="text-lg text-neutral-600 leading-relaxed max-w-2xl">{subtitle}</p>
        )}
      </div>
    </section>
  );
};

export default PageHeader;
